import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../../shared/spinner.service'
import { session } from '../../../../environments/environment.session'
import { DepartmentService } from '../../service/department.service'
import Swal from 'sweetalert2';
// export interface DepartmentMapping {
//   id: number;
//   departmentName: string;
//   code: string;
//   escalationStartLevel: string;
//   status: string;
// }

@Component({
  selector: 'app-dep-management',
  templateUrl: './dep-management.component.html',
  styleUrls: ['./dep-management.component.css']
})
export class DepManagementComponent implements OnInit {
  departmentMappings: any[] = [];
  filteredDepartmentList: any[] = [];
  pagedDepartments: any[] = [];

  searchText: string = '';
  escalationLevels: string[] = [
    'Level 1 - Junior Engineer/Field Officer',
    'Level 2 - Assistant Engineer',
    'Level 3 - Executive Engineer'
  ];

  newDepartment: any = {
    departmentName: '',
    code: '',
    escalationStartLevel: '',
    isActive: true
  };

  // Pagination variables
  currentPage = 1;
  pageSize = 20;
  totalPages = 0;
  page_list = [5, 10, 20, 50, 100];
  totalRecords = 0;
  selectedDepartment: any = null;
  isEditMode: boolean = false;

  constructor(private depS: DepartmentService, private modalService: NgbModal, private tspinner: SpinnerService) { }
  erpUser: any
  ngOnInit(): void {
    this.erpUser = JSON.parse(atob(session.erpUser))
    this.getDepartments();
  }

  open(modalRef: any, department: any = null): void {
    if (department) {
      this.isEditMode = true;
      this.selectedDepartment = department;
      this.newDepartment = {
        id: department.id,
        dep_id: department.dep_id,
        department_name: department.department_name,
        dep_cd: department.dep_cd,
        status: department.status === 'ACTIVE' ? 1 : 0
      };
    } else {
      this.isEditMode = false;
      this.selectedDepartment = null;
      this.newDepartment = {
        department_name: '',
        dep_cd: '',
        status: 1

      };
    }

    this.modalService.open(modalRef, { windowClass: 'modal-md-custom', size: 'lg', backdrop: 'static', centered: true });
  }


  allDepartment: any = []
  async getDepartments() {

    let obj = { b_acct_id: this.erpUser.b_acct_id }
    this.tspinner.show('', '')
    let resp = await this.depS.getDepartment(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allDepartment = resp['data']
      this.tspinner.hide()
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
    }

    this.applyFilters();
  }
  // async getDepartments() {
  //   let obj = { b_acct_id: this.erpUser.b_acct_id }

  //   let resp = await this.depS.getDepartment(JSON.stringify(obj));

  //   if (resp['error'] == false) {
  //     this.allDepartment = resp['data'].map((dept: any) => ({
  //       ...dept,
  //       status: dept.status == 1 ? 'Active' : 'Inactive'
  //     }));
  //   } else {
  //     Swal.fire('Opps !!', resp['data'], 'error');
  //   }
  //   this.applyFilters();
  //   this.tspinner.hide();
  // }

  applyFilters(): void {
    this.filteredDepartmentList = this.allDepartment.filter((dept: any) =>
      dept.department_name.toLowerCase().includes(this.searchText.toLowerCase())
    );
    this.totalRecords = this.filteredDepartmentList.length;
    this.updatePages();
    this.updatePagedData();
  }

  updatePages(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
  }

  updatePagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedDepartments = this.filteredDepartmentList.slice(start, end);
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  changePageSize(): void {
    this.currentPage = 1;
    this.updatePages();
    this.updatePagedData();
  }

  onSearchChange(): void {
    this.currentPage = 1;
    this.applyFilters();
  }

  formatDepartmentName(name: string): string {
    return name.replace(/\n/g, '<br>');
  }

  onEdit(mapping: any): void {
    console.log('Edit clicked for:', mapping);
  }

  async onDelete(mapping: any) {

    // this.departmentMappings = this.departmentMappings.filter(d => d.id !== mapping.id);
    // this.applyFilters();
  }

  // async addDepartment() {
  //   if (!this.newDepartment.department_name || !this.newDepartment.dep_cd) {
  //     Swal.fire('Opps !! ', 'Please fill all required fields.', 'info');
  //     return;
  //   }

  //   let obj = { b_acct_id: this.erpUser.b_acct_id, create_user_id: this.erpUser.le_id, ...this.newDepartment }

  //   let resp = await this.depS.addDepartment(obj)
  //   if (resp['error'] == false) {
  //     await this.getDepartments()
  //     this.modalService.dismissAll();
  //     this.applyFilters();
  //     Swal.fire('Success', resp['data'], 'success')
  //   } else {
  //     Swal.fire('Opps !!', resp['data'], 'info')
  //   }
  // }


  // const newId = this.departmentMappings.length
  //     ? Math.max(...this.departmentMappings.map(d => d.id)) + 1
  //     : 1;

  //   const newEntry: DepartmentMapping = {
  //     id: newId,
  //     departmentName: this.newDepartment.departmentName,
  //     code: this.newDepartment.code,
  //     escalationStartLevel: this.newDepartment.escalationStartLevel,
  //     status: this.newDepartment.isActive ? 'Active' : 'Inactive'
  //   };
  // this.departmentMappings.push(newEntry);

  async addDepartment() {
    // Trimmed values
    const deptName = this.newDepartment.department_name?.trim();
    const deptCode = this.newDepartment.dep_cd?.trim();

    // Validate required fields after trimming
    if (!deptName || !deptCode) {
      Swal.fire('Oops !!', 'Please fill all required fields.', 'info');
      return;
    }

    // Check for duplicate code (case insensitive)
    const codeExists = this.allDepartment.some(
      (dept: any) => dept.dep_cd.toLowerCase() === deptCode.toLowerCase()
    );

    if (codeExists) {
      Swal.fire('Duplicate Code', 'This department code already exists.', 'error');
      return;
    }

    let obj = {
      b_acct_id: this.erpUser.b_acct_id,
      create_user_id: this.erpUser.le_id,
      department_name: deptName,
      dep_cd: deptCode,
      status: this.newDepartment.status
    };
    this.tspinner.show('', '')
    let resp = await this.depS.addDepartment(obj);

    if (resp['error'] == false) {
      await this.getDepartments();
      this.modalService.dismissAll();
      this.applyFilters();
      this.tspinner.hide()
      Swal.fire('Success', resp['data'], 'success');
    } else {
      this.tspinner.hide()
      Swal.fire('Oops !!', resp['data'], 'info');
    }
  }

  async updateDepartment() {

    const result = await Swal.fire({
      title: 'Are you Sure !!',
      text: `After update you can't retrive it?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    });

    if (!result.isConfirmed) {
      return
    }

    let obj: any = { ...this.newDepartment }

    if (!this.newDepartment.dep_cd?.trim()) {
      Swal.fire('Oops !!', 'Department Code is required.', 'info');
      return;
    }

    if (!this.newDepartment.department_name?.trim()) {
      Swal.fire('Oops !!', 'Department Name is required.', 'info');
      return;
    }

    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['create_user_id'] = this.erpUser.le_id
    obj['update_user_id'] = this.erpUser.le_id
    obj['update_status'] = 'UPDATED'
    this.tspinner.show('', '')
    let resp = await this.depS.updateDepartment(obj);
    if (resp['error'] == false) {
      await this.getDepartments();
      this.modalService.dismissAll();
      this.applyFilters();
      this.tspinner.hide()
      Swal.fire('Success', resp['data'], 'success');
    } else {
      this.tspinner.hide()
      Swal.fire('Oops !!', resp['data'], 'info');
    }

    // const deptName = this.newDepartment.department_name?.trim();
    // const deptCode = this.newDepartment.dep_cd?.trim();

    // if (!deptName || !deptCode) {
    //   Swal.fire('Oops !!', 'Please fill all required fields.', 'info');
    //   return;
    // }

    // const index = this.allDepartment.findIndex(
    //   (dept: any) => dept.dep_cd === this.selectedDepartment.dep_cd
    // );

    // if (index !== -1) {
    //   this.allDepartment[index] = {
    //     ...this.allDepartment[index],
    //     department_name: deptName,
    //     dep_cd: deptCode,
    //     status: this.newDepartment.status
    //   };
    // }

    // this.modalService.dismissAll();
    // this.applyFilters();

    // Swal.fire('Success', 'Department updated successfully.', 'success');
  }


  async deleteDepartment(element: any) {

    const result = await Swal.fire({
      title: 'Are you Sure !!',
      text: `After delete you can't retrive it?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    });

    if (!result.isConfirmed) {
      return
    }

    let obj: any = {}
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['create_user_id'] = this.erpUser.le_id
    obj['update_user_id'] = this.erpUser.le_id
    obj['dep_id'] = element.dep_id
    obj['id'] = element.id
    obj['status'] = 'DELETED'
    this.tspinner.show('', '')
    let resp = await this.depS.deleteDepartment(JSON.stringify(obj));
    if (resp['error'] == false) {
      await this.getDepartments();
      this.applyFilters();
      this.tspinner.hide()
      Swal.fire('Success', resp['data'], 'success');
    } else {
      this.tspinner.hide()
      Swal.fire('Oops !!', resp['data'], 'info');
    }

    // const deptName = this.newDepartment.department_name?.trim();
    // const deptCode = this.newDepartment.dep_cd?.trim();

    // if (!deptName || !deptCode) {
    //   Swal.fire('Oops !!', 'Please fill all required fields.', 'info');
    //   return;
    // }

    // const index = this.allDepartment.findIndex(
    //   (dept: any) => dept.dep_cd === this.selectedDepartment.dep_cd
    // );

    // if (index !== -1) {
    //   this.allDepartment[index] = {
    //     ...this.allDepartment[index],
    //     department_name: deptName,
    //     dep_cd: deptCode,
    //     status: this.newDepartment.status
    //   };
    // }

    // this.modalService.dismissAll();
    // this.applyFilters();

    // Swal.fire('Success', 'Department updated successfully.', 'success');
  }

}
